import React, { useEffect, useState } from 'react'
// import * as Yup from 'yup'
import { useFormik } from 'formik'
import Switch from "../../../../../../../../../core/Switch"
import Svg from '../../../../../../../../../component/common/Svg'
import Callout from '../../../../../../../../../core/Callout'
import iicon from '../../../../../../../../../assets/images/i-icon.png'
import Input from "../../../../../../../../../core/Inputs/DefaultInput"
import { useDispatch } from 'react-redux'
import { updateQuestion, updateQuestionControl, updateQuestionHint } from '../../../../../../../../../store/actions/qnaBuilderAction'
import { getTokenData } from '../../../../../../../../../store/actions/authAction'
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import Card from '../../../../../../../../../core/Card/Card'
import style from "../../../../../../../../style.module.css";
import Tooltip from "../../../../../../../../../core/Tooltip";
import CustomVariableValue from '../modals/CustomVariableValue'
import { useTranslation } from 'react-i18next';

const MultipleChoicePreview = ({ survey_id, questionId, setIsVisibleCollapse, language_code, questionIndex, isVisibleCollapse, collapseMode, setCollapseMode, collapseModes, question }) => {

  //==> STATES <==
  const [varibleModalData, setVaribleModalData] = useState(null)
  const [optionCount, setOptionCount] = useState(null)
  const [questionText, setQuestionText] = useState(null)
  const [currentlyDeleting, setCurrentlyDeleting] = useState(null)
  const [userId, setuserId] = useState('');

  //Others
  const dispatch = useDispatch()
  const { t, i18n } = useTranslation();
  //==> FORM SCHEMA AND VALIDATION <==

  //Formik
  const initialValues = {
    options: [],
    score: [],
    hint: '',
  }

  const formik = useFormik({
    initialValues: initialValues,
  })

  const {
    values,
    touched,
    setFieldValue,
    setFieldTouched,
    handleChange,
    handleBlur
  } = formik


  //==> FUNCTIONALITIES <==

  //React-beautiful-dnd

  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
  }

  const onDragEnd = (result, opt, score) => {
    if (window.modulePermissions.M11.edit != 1) {
      return;
    }
    if (!result.destination) {
      return;
    }

    if (result.destination.index === result.source.index) {
      return;
    }

    let optArr = Object.keys(opt ?? {})?.map((key) => (opt[key]))
    let scoreArr = Object.keys(score ?? {})?.map((key) => (score[key]))

    const tmpOpt = reorder(
      optArr,
      result.source.index,
      result.destination.index
    )

    const tmpScore = reorder(
      scoreArr,
      result.source.index,
      result.destination.index
    )

    let chnagedOpt = {}
    let changedScore = {}
    tmpOpt?.forEach((item, index) => { chnagedOpt[index] = item })
    tmpScore?.forEach((item, index) => { changedScore[index] = item })

    setFieldValue('options', chnagedOpt)
    setFieldValue('score', changedScore)
  }


  //Handle view chage
  const handleViewChange = (mode) => {
    setCollapseMode(mode)
  }

  //Options handling
  const handleDelete = (options, scores, key) => {
    delete options[key]
    delete scores[key]
    setFieldValue('options', options)
    setFieldValue('score', scores)
  }

  const handleAdd = (options, scores, optionTouched, scoreTouched) => {
    options[optionCount] = ''
    scores[optionCount] = 0
    optionTouched[optionCount] = false
    scoreTouched[optionCount] = false
    setFieldValue('options', options)
    setFieldValue('score', scores)
    setFieldTouched('options', optionTouched)
    setFieldTouched('score', scoreTouched)
    setOptionCount(optionCount + 1)
  }

  const handleSave = (options, score) => {
    const payloadOption = {
      qid: questionId,
      qtxt: questionText,
      qtype: 1,
      qopts: {
        common: {
          score: score
        },
        optionsText: {
          22: options
        }
      },
      qorderno: questionIndex,
      qsection: question.sectionId,
      added_by: userId,
      qsurvey: survey_id,
      language_code: language_code
    }
    dispatch(updateQuestion(payloadOption, afterSave))
  }

  const afterSave = () => {
    setCollapseMode(collapseModes.preview)
  }

  const handleCancel = () => {
    setIsVisibleCollapse(false)
    setInitialData()
  }

  const setInitialData = () => {
    let tmpScore = question?.options?.common?.score
    let tmpOptions = question?.options?.optionsText
    tmpOptions = tmpOptions && tmpOptions[language_code]

    if (tmpOptions && tmpScore) {
      let option = {}
      let score = {}
      let tmptouched = {}
      Object.keys(tmpOptions ?? {})?.forEach((key, index) => {
        option[index] = tmpOptions[key]
        score[index] = tmpScore[key]
        tmptouched[index] = false
      });
      setOptionCount(Object.keys(tmpOptions).length)
      setFieldValue('score', score)
      setFieldValue('options', option)
      setFieldTouched('options', tmptouched)
      setFieldTouched('score', tmptouched)
    }
    else {
      let tmptouched = {
        0: false,
        1: false,
        2: false,
        3: false
      }
      let values = {
        0: '',
        1: '',
        2: '',
        3: ''
      }
      setOptionCount(4)
      setFieldValue('score', values)
      setFieldValue('options', values)
      setFieldTouched('options', tmptouched)
      setFieldTouched('score', tmptouched)
    }
  }

  const handleIsRequired = (e) => {
    const payload = {
      column: e.target.value,
      value: (e.target.checked) ? 1 : 0,
      question_id: questionId
    }
    dispatch(updateQuestionControl(payload))
  }

  const handleIsScore = (e) => {
    const payload = {
      column: e.target.value,
      value: (e.target.checked) ? 1 : 0,
      question_id: questionId
    }
    dispatch(updateQuestionControl(payload))
  }

  const handleUpdateQuestionHint = (id, text) => {
    const payload = {
      language_code: language_code,
      id,
      text
    }
    dispatch(updateQuestionHint(payload))
  }

  const handleBlurQuestionHint = (e, { questionId }, text) => {
    handleBlur(e)
    handleUpdateQuestionHint(questionId, text)
  }


  //==> Effects <==
  useEffect(() => {
    if (question) {
      setInitialData()
      setQuestionText(question.questionText)
      setFieldValue('hint', question?.questionHint ?? '')
    }
  }, [question])

  useEffect(() => {
    dispatch(getTokenData(setuserId))
  }, [userId, dispatch])

  return (
    <>
      <div key={questionId} className={`${isVisibleCollapse ? 'show' : ''} accordion-collapse collapse`} data-bs-parent="#surveyaccordian">
        <div className="accordion-body"> {/* add class "preview" once preview is opened*/}

          {/* Editor Wrap */}
          {collapseMode === collapseModes?.edit && <div className="editor-wrap">
            <div className="question-edit">
              <div className="choices-scrore-wrapper">
                <>
                  {(isVisibleCollapse && collapseMode === collapseModes.edit) && <>
                    <div className="text mb-3">
                      <Input
                        type="text"
                        view="outlined"
                        color="default"
                        label=""
                        placeholder= {t('settings.questionnaire.hint')}
                        value={values.hint}
                        onClick={((e) => e.stopPropagation())}
                        fill
                        name='hint'
                        onChange={window.modulePermissions.M11.edit == 1 ? handleChange : undefined}
                        onBlur={window.modulePermissions.M11.edit == 1 ? (e) => { handleBlurQuestionHint(e, question, values.hint) } : undefined}
                        readOnly={window.modulePermissions.M11.edit != 1}
                        className={"formsinput " + style.card__exp}
                      />
                    </div>
                  </>
                  }
                </>

                <div className="title-wrap d-flex">
                  <div className="choices flex-grow-1"> {t('settings.questionnaire.choice')}</div>
                  <div className="score">{t('settings.CustomVairable.score')}</div>
                </div>

                <DragDropContext onDragEnd={(result) => onDragEnd(result, values?.options, values?.score)}>
                  <Droppable droppableId="optionsList">
                    {provided => (
                      <div className="data-outer" ref={provided.innerRef} {...provided.droppableProps}>
                        {
                          Object.keys(values?.options)?.map((key, index) => {
                            const score = values.score
                            return (
                              <Draggable draggableId={`optionsList${index}`} index={index} key={index}>
                                {provided => (
                                  <div
                                    className="data-wrap d-flex"
                                    key={index}
                                    ref={provided.innerRef}
                                    {...provided.draggableProps}>
                                    <div className="choices flex-grow-1 position-relative">
                                      <Input
                                        type='text'
                                        view='outlined'
                                        dense={false}
                                        color='default'
                                        label=''
                                        placeholder='Option Here'
                                        success={false}
                                        error={false}
                                        fill={true}
                                        errorHelperText={null}
                                        className={"formsinput"}
                                        value={values?.options && values?.options[key]}
                                        onChange={window.modulePermissions.M11.edit == 1 ? (e) => { setFieldValue('options', { ...values?.options, [key]: e.target.value }) } : undefined}
                                        onBlur={window.modulePermissions.M11.edit == 1 ? () => { setFieldTouched('options', { ...touched?.options, [key]: true }) } : undefined}
                                        readOnly={window.modulePermissions.M11.edit != 1}
                                      />
                                      {touched.options && touched.options[key] && values?.options && !values.options[key] && <div className='validation-msg'>Please enter option</div>}
                                    </div>
                                    <div className="score d-flex align-items-center">
                                      {Number(question?.isScore) === 1 &&
                                        <div className="score-wrap">
                                          <Input
                                            type='number'
                                            view='outlined'
                                            dense={false}
                                            color='default'
                                            label=''
                                            placeholder=''
                                            success={false}
                                            error={false}
                                            fill={true}
                                            errorHelperText={null}
                                            className={"formsinput"}
                                            value={score[key] ?? ''}
                                            onChange={window.modulePermissions.M11.edit == 1 ? (e) => { setFieldValue('score', { ...values?.score, [key]: e.target.value }) } : undefined}
                                            onBlur={window.modulePermissions.M11.edit == 1 ? () => { setFieldTouched('score', { ...touched?.score, [key]: true }) } : undefined}
                                            readOnly={window.modulePermissions.M11.edit != 1}
                                          />
                                          {touched.score && touched.score[key] && score && !score[key] && <div className='validation-msg'>Required</div>}
                                        </div>}
                                      <div className="btn-wrap d-flex align-tems-center">
                                        {window.modulePermissions.M11.edit == 1 && <Tooltip
                                          color='primary'
                                          content= {t('survey.customVariable.customVariables')}
                                          position='top'
                                          className='black-tooltip'
                                        >
                                          <button className='btn btn-custom-variable' data-bs-toggle="modal" data-bs-target={`#linkCustomVariable-${question.questionId}-${key}`} onClick={() => {
                                            setVaribleModalData({...question, surveyId: survey_id, componentID: key, componentType:"option"});
                                          }}>
                                            <Svg name="custom-variable" />
                                          </button>
                                        </Tooltip>}
                                        {window.modulePermissions.M11.del == 1 && <button className='btn btn-dlt' data-bs-toggle="modal" data-bs-target={`#deleteOptionModal${questionId}`} onClick={() => setCurrentlyDeleting({ options: values?.options, score: values.score, key })}>
                                          <Svg name="section-delete" />
                                        </button>}
                                        {window.modulePermissions.M11.edit == 1 && <button  className='btn btn-move' {...provided.dragHandleProps}>
                                          <Svg name="draggable" />
                                        </button>}
                                      </div>
                                      <div
                                        className="customvar-modal modal fade setting-modal"
                                        id={`linkCustomVariable-${questionId}-${key}`}
                                      >
                                        <div className="modal-dialog modal-dialog-centered modal-lg">
                                          <div className="modal-content">
                                          <CustomVariableValue key={`${question.questionId}-${key}`} varibleModalData={varibleModalData}/>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )
                                }
                              </Draggable>
                            )
                          })
                        }
                        {provided.placeholder}
                      </div>
                    )}
                  </Droppable>
                </DragDropContext>

              </div>
              <div className="button-wrap d-flex add-cancel-btn">
                {window.modulePermissions.M11.add == 1 && <button className='btn btn-bordered' onClick={() => handleAdd(values?.options, values.score, touched?.options, touched?.score)}>{t('settings.CustomVairable.newchoices')}</button>}
                <div className="ps-3 flex-grow-1 d-flex align-items-center action-buttons justify-content-end">
                  <button className='btn btn-bordered' onClick={() => handleCancel()}>{t('settings.CustomVairable.cancel')}</button>
                  {window.modulePermissions.M11.edit == 1 && <button className='btn btn-primary' onClick={() => handleSave(values?.options, values?.score)}>{t('settings.CustomVairable.save')}</button>}
                </div>
              </div>
            </div>
          </div>}

          {/* Preview Wrap */}
          {collapseMode === collapseModes?.preview && <div className='d-flex flex-wrap flex-column question-preview-pg'>
            <div className="preview-header">
              <div className="radio-btn-screen d-inline-flex align-items-center justify-content-center">
                <div className="form-check form-check-inline">
                  <input className="form-check-input" type="radio" name="screenSize" id="Desktop" defaultValue="Desktop" defaultChecked />
                  <label className="form-check-label" htmlFor="Desktop" title="Desktop">
                    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12 17H21C22.1046 17 23 16.1046 23 15V5C23 3.89543 22.1046 3 21 3H3C1.89543 3 1 3.89543 1 5V15C1 16.1046 1.89543 17 3 17H12ZM12 17V21M12 21H16M12 21H8" stroke="#0F2744" strokeWidth="1.5" strokeLinecap="round" />
                    </svg>
                  </label>
                </div>
                <div className="form-check form-check-inline">
                  <input className="form-check-input" type="radio" name="screenSize" id="Tablet" defaultValue="Tablet" />
                  <label className="form-check-label" htmlFor="Tablet" title="Tablet">
                    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M11 18.25C10.5858 18.25 10.25 18.5858 10.25 19C10.25 19.4142 10.5858 19.75 11 19.75V18.25ZM13 19.75C13.4142 19.75 13.75 19.4142 13.75 19C13.75 18.5858 13.4142 18.25 13 18.25V19.75ZM6 1.75H18V0.25H6V1.75ZM19.25 3V21H20.75V3H19.25ZM4.75 21V3H3.25V21H4.75ZM18 22.25H6V23.75H18V22.25ZM11 19.75H13V18.25H11V19.75ZM3.25 21C3.25 22.5188 4.48122 23.75 6 23.75V22.25C5.30964 22.25 4.75 21.6904 4.75 21H3.25ZM19.25 21C19.25 21.6904 18.6904 22.25 18 22.25V23.75C19.5188 23.75 20.75 22.5188 20.75 21H19.25ZM18 1.75C18.6904 1.75 19.25 2.30964 19.25 3H20.75C20.75 1.48122 19.5188 0.25 18 0.25V1.75ZM6 0.25C4.48122 0.25 3.25 1.48122 3.25 3H4.75C4.75 2.30964 5.30964 1.75 6 1.75V0.25Z" fill="#0F2744" />
                    </svg>
                  </label>
                </div>
                <div className="form-check form-check-inline">
                  <input className="form-check-input" type="radio" name="screenSize" id="Mobile" defaultValue="Mobile" />
                  <label className="form-check-label" htmlFor="Mobile" title="Mobile">
                    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M11 18.25C10.5858 18.25 10.25 18.5858 10.25 19C10.25 19.4142 10.5858 19.75 11 19.75V18.25ZM13 19.75C13.4142 19.75 13.75 19.4142 13.75 19C13.75 18.5858 13.4142 18.25 13 18.25V19.75ZM8 1.75H16V0.25H8V1.75ZM17.25 3V21H18.75V3H17.25ZM6.75 21V3H5.25V21H6.75ZM16 22.25H8V23.75H16V22.25ZM11 19.75H13V18.25H11V19.75ZM5.25 21C5.25 22.5188 6.48122 23.75 8 23.75V22.25C7.30964 22.25 6.75 21.6904 6.75 21H5.25ZM17.25 21C17.25 21.6904 16.6904 22.25 16 22.25V23.75C17.5188 23.75 18.75 22.5188 18.75 21H17.25ZM16 1.75C16.6904 1.75 17.25 2.30964 17.25 3H18.75C18.75 1.48122 17.5188 0.25 16 0.25V1.75ZM8 0.25C6.48122 0.25 5.25 1.48122 5.25 3H6.75C6.75 2.30964 7.30964 1.75 8 1.75V0.25Z" fill="#0F2744" />
                    </svg>
                  </label>
                </div>
                <div className="form-check form-check-inline">
                  <button className="full-screen-btn" title="View full screen">
                    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M14 18V16C14 14.8954 14.8954 14 16 14H18" stroke="#0F2744" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M9 6L9 8C9 9.10457 8.10457 10 7 10L5 10" stroke="#0F2744" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M5 14L7 14C8.10457 14 9 14.8954 9 16L9 18" stroke="#0F2744" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M18 10L16 10C14.8954 10 14 9.10457 14 8L14 6" stroke="#0F2744" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
            <div className="flex-grow-1 page-content-wrap d-flex align-items-center">
              <div className="container">
                <div className="question-wrapper">
                  <div className="heading">
                    <h3>Q{questionIndex}. {questionText}</h3>
                  </div>
                  <div className="question-list-wrapper">
                    <ul className='question-list'>
                      {
                        Object.keys(values?.options)?.map((key, index) => {
                          return (
                            <li key={index}>
                              <div className="form-check d-flex align-items-center">
                                <input className="form-check-input" name={`questionCheck${questionId}`} type="radio" id={`questionCheck${questionId}${index}`} defaultChecked={index === 0} />
                                <label htmlFor={`questionCheck${questionId}${index}`}>{values?.options && values?.options[key]}</label>
                              </div>
                            </li>
                          )
                        })
                      }
                    </ul >
                  </div>
                </div>
              </div>
            </div>
          </div>}

          {/* Footer Wrap */}
          <div className="opinion-scale bottom-buttons-wrap bottomBtns d-flex align-items-center justify-content-between">
            <div className="select-language d-flex align-items-center">
              {collapseMode === collapseModes?.edit && <>
                <div className="dropdown table-dropdown ques-options">
                  {/* <button className="btn dropdown-tgl" type="button" id="languages" data-bs-toggle="dropdown"
                    aria-haspopup="true" aria-expanded="false">
                    <span className='me-2'>English</span>
                  </button> */}
                  {/* <div className="dropdown-menu" aria-labelledby="languages">
                    <a className="dropdown-item"> English </a>
                    <a className="dropdown-item"> German </a>
                    <a className="dropdown-item"> Spanish </a>
                  </div> */}
                </div>
              </>}
            </div>
            {/* <div className="accoriancon-right center-field d-flex align-items-center flex-wrap">
              <div className="action-wrapper d-flex accordianSwitch">
                < Switch
                  type='dense'
                  color='default'
                  checked={false}
                  disabled={false}
                  label='Add “None of the above”'
                  fill={false}
                  rtl={false}
                  leftPosition={false}
                  className='SwitchCustom'
                />
              </div>
              <div className="action-wrapper d-flex accordianSwitch ms-3">
                < Switch
                  type='dense'
                  color='default'
                  checked={false}
                  disabled={false}
                  label='Add “All of the above”'
                  fill={false}
                  rtl={false}
                  leftPosition={false}
                  className='SwitchCustom'
                />
              </div>
            </div> */}

            <div className="accoriancon-right d-flex align-items-center flex-wrap justify-content-end">
              {collapseMode === collapseModes?.edit && <>
                {/* <div className="action-wrapper d-flex accordianSwitch">
                  < Switch
                    type='dense'
                    color='default'
                    disabled={false}
                    label=  {t('survey.builder.required')}
                    fill={false}
                    rtl={false}
                    leftPosition={false}
                    className='SwitchCustom'
                    checked={Number(question?.required) === 1}
                    value={'su_is_required'}
                    onChange={handleIsRequired}
                  />
                </div> */}
                <div className="action-wrapper d-flex accordianSwitch ms-3">
                  < Switch
                    type='dense'
                    color='default'
                    disabled={window.modulePermissions.M11.edit != 1}
                    label={t('settings.CustomVairable.score')}
                    fill={false}
                    rtl={false}
                    leftPosition={false}
                    className='SwitchCustom'
                    checked={Number(question?.isScore) === 1}
                    value={'su_is_score'}
                    onChange={window.modulePermissions.M11.edit == 1 ? handleIsScore : undefined}
                  />

                  {/* <div className="tooltipInit ms-2 custom-callout-init">
                    <img src={iicon} alt="info" />
                    <div className='infobox custom-callout'>
                      < Callout
                        type='def'
                        view='outlined'
                        color='primary'
                        title={t('settings.CustomVairable.score')}
                        icon={<Svg name="primary-info" />}
                      >
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum eleifend arcu laoreet elit maximus, eu accumsan tortor suscipit.
                      </Callout >

                    </div>
                  </div> */}
                </div>
              </>}
              {window.modulePermissions.M11.edit == 1 && (
              <div className="switch-button d-flex align-items-center">
                <div className="form-check">
                  <input className="form-check-input"
                    type="radio"
                    name={`collapseModeChange-${questionId}`}
                    id={`edit-view-q${questionId}`}
                    checked={collapseMode === collapseModes.edit}
                    onChange={() => handleViewChange(collapseModes.edit)}
                  />
                  <label className="form-check-label" htmlFor={`edit-view-q${questionId}`}>
                  {t('survey.builder.edit')}
                  </label>
                </div>
                <div className="form-check">
                  <input className="form-check-input"
                    type="radio"
                    name={`collapseModeChange-${questionId}`}
                    id={`preview-view-q${questionId}`}
                    checked={collapseMode === collapseModes.preview}
                    onChange={() => handleViewChange(collapseModes.preview)}
                  />
                  <label className="form-check-label" htmlFor={`preview-view-q${questionId}`}>
                  {t('survey.builder.preview')}
                  </label>
                </div>
              </div>
              )}
            </div>
          </div>
        </div>
      </div >

      <div className="customvar-modal modal custom-modal fade deleteModal" id={`deleteOptionModal${questionId}`} tabIndex={-1} aria-labelledby="deleteModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <div className={"formcontainer" + " " + style.container}>
                <div className={"formvawrapper delete-modal-wrap modal-sm" + " " + style.wrapper}>
                  <Card view="raised" className={"formstyle p-0" + " " + style.card} >

                    <div className="delete-body-wrap delete-language">
                      <div className="heading">
                        <h3>{t('survey.actions.delete')}</h3>
                        <p>{t('settings.CustomVairable.areYouSure')} </p>
                      </div>
                      <div className="button-wrap d-flex justify-content-end">
                        <button type="button" className="btn btn-bordered" data-bs-dismiss="modal" onClick={() => setCurrentlyDeleting(null)}>{t('settings.CustomVairable.cancel')}</button>
                        <button type="button" className="btn btn-delete ms-3" data-bs-dismiss="modal" onClick={() => handleDelete(currentlyDeleting.options, values.score, currentlyDeleting.key)}>{t('settings.CustomVairable.confirmDelete')}</button>
                      </div>
                    </div>
                  </Card>
                </div >
              </div >
            </div>
          </div>
        </div>
      </div>

    </>
  )
}

export default MultipleChoicePreview